<style lang="scss" scoped>
.tip-card {
    box-shadow: 8px 8px 10px rgba(0, 0, 0, 0.06);
    background-color: #ffffff;
    position: relative;
    &:not(.locked) {
        cursor: pointer;
    }
    &.locked {
        overflow: hidden;
    }
    .tip-img {
        width: 100%;
        height: 158px;
        overflow: hidden;
        .blurred {
            filter: blur(3px);
            width: 102%;
            height: 102%;
            margin-left: -1%;
            margin-top: -1%;
        }
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
    .tip-tags {
        display: flex;
        flex-wrap: wrap;
        margin: -4px;
        &.top {
            position: absolute;
            top: 125px;
            margin-bottom: 0 !important;
            overflow: hidden;
            width: 100%;
            left: 0;
            padding: 0 16px;
            height: 25px;
            .tag {
                margin: 0 4px;
            }
        }
        .tag {
            background: #fff;
            box-shadow: -8px 0 12px rgba(0, 0, 0, 0.06);
            border-radius: 3px;
            margin: 0 4px 8px 4px;
            padding: 4px 8px;
            font-weight: 400;
        }
    }
    .overlay {
        height: 158px;
        width: 100%;
        background: #fff;
        position: absolute;
        opacity: 0.6;
        z-index: 1;
    }
    .tip-locked {
        position: absolute;
        top: 16px;
        right: 16px;
        z-index: 2;
    }
    .tip-type {
        background: #fff;
        color: var(--primary-dark);
        padding: 4px 8px;
        margin-left: -8px;
        width: auto;
        &.top {
            margin-left: 0;
            position: absolute;
            top: 16px;
            left: 16px;
            box-shadow: -6px 0 12px rgba(0, 0, 0, 0.1);
            border-radius: 12px;
        }
        .w-15 {
            width: auto;
            height: 15px;
            display: block;
        }
    }
}
</style>

<template>
    <div class="tip-card mb-48" :class="{ 'locked' : disabled }" @click.prevent="goTo(data[goToLink])">
        <div v-if="disabled" class="overlay d-flex">
            <div class="m-auto d-flex flex-column p-16 text-center">
                <i-lock class="i-20 mb-16 mx-auto"></i-lock>
                <p class="fw-b text-dark small">{{ $t('pages.tips.unlock') }}</p>
            </div>
        </div>
        <div class="tip-img">
            <img :class="{ 'blurred' : disabled }" v-if="data.file_preview" :src="data.file_preview.default" alt="">
        </div>
        <div class="p-16">
            <div class="tip-type small d-flex flex-wrap" :class="{ 'top' : data.file_preview }">
                <i-bulb class="w-15 mr-8 my-auto"></i-bulb>
                {{ $t('pages.tips.tip') }}
            </div>
            <div class="tip-type small d-flex flex-wrap" :class="{ 'top' : data.file_preview }" style="left: 75px">
                {{  $t('pages.tips.day_x', { day: data.day }) }}
            </div>
            <p class="tip-title text-primary-dark fw-b mb-16">{{ data.title }}</p>
            <div class="tip-tags mb-8" :class="{ 'top' : data.img }" v-if="data.tip_categories.length > 0 && showTags">
                <div class="tag small" v-for="(tag, key) in data.tip_categories" :key="key">{{ tag }}</div>
            </div>
            <div class="small">
                {{ data.preview | striphtml }} ...
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'tip-card',
    props: {
        data: {
            required: true,
            type: Object
        },
        link: {
            default: 'tip-detail'
        },
        goToLink: {
            default: 'day'
        },
        showTags: {
            default: false
        },
        disabled: {
            default: false
        }
    },
    methods: {
        goTo(id) {
            if (!this.disabled)
                this.$router.push({ name: this.link, params: { id: id } })
        }
    },
    filters: {
        striphtml(value) {
            var div = document.createElement("div");
            div.innerHTML = value;
            var text = div.textContent || div.innerText || "";
            return text.slice(0, 100);
        }
    }
}
</script>

